import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarHeart, ArrowRight, Plus } from "lucide-react";
import { StatusBadge } from "../../components/shared/StatusBadge";
import { EmptyState } from "../../components/shared/EmptyState";
import { api } from "../../lib/api";

export default function ClientDashboard() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/client/events").then((r) => setEvents(r.data)).catch(() => setEvents([])).finally(() => setLoading(false));
  }, []);
  return (
    <div data-testid="client-dashboard">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h2 className="font-heading text-2xl text-deepgreen">Mes événements</h2>
          <p className="mt-1 text-sm text-muted-foreground">Chaque événement regroupe ses réservations, paiements, documents et messages.</p>
        </div>
        <Link to="/boutique" className="btn-secondary-ae !px-5 !py-2.5 !text-xs" data-testid="client-new-event">
          <Plus className="h-4 w-4" /> Nouvel événement
        </Link>
      </div>
      {!loading && events.length === 0 && (
        <div className="mt-8">
          <EmptyState title="Aucun événement pour le moment">Vos événements apparaîtront ici après l'envoi d'une première demande de location.</EmptyState>
        </div>
      )}
      <div className="mt-6 grid gap-6 md:grid-cols-2">
        {events.map((evt) => (
          <Link
            key={evt.id}
            to={`/compte/evenements/${evt.id}`}
            data-testid={`client-event-${evt.id}`}
            className="card-ae group overflow-hidden transition-transform duration-300 hover:-translate-y-1"
          >
            <div className="relative h-40 overflow-hidden bg-gradient-to-br from-deepgreen via-sage to-gold/70">
              <div className="absolute inset-0 bg-gradient-to-t from-deepgreen/60 to-transparent" />
              <div className="absolute bottom-3 left-4"><StatusBadge status={evt.status} /></div>
            </div>
            <div className="p-6">
              <h3 className="font-heading text-xl text-deepgreen">{evt.title}</h3>
              <p className="mt-1 text-sm text-muted-foreground">{evt.date_start}{evt.date_end && evt.date_end !== evt.date_start ? ` → ${evt.date_end}` : ""} — {evt.venue_address || "Lieu à préciser"}</p>
              <div className="mt-3 flex flex-wrap gap-2">
                <span className="rounded-full bg-sage-light px-3 py-1 text-xs font-semibold text-deepgreen">Location</span>
                {evt.has_coordination && (
                  <span className="rounded-full bg-gold-light px-3 py-1 text-xs font-semibold text-deepgreen">Coordination</span>
                )}
              </div>
              <span className="mt-4 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.12em] text-deepgreen">
                Ouvrir le dossier <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-1" />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
